import React, { memo } from 'react';
import { useDispatch } from 'react-redux';
import { Select } from 'antd';
import { useRequestFilterCommands } from '../../../../model/commandsContext';
import { compactMultiSelectTagProps } from '../../../primitives/selectTagProps';
import { useSetFilterChanged } from '../lib/utils';

const createContent = (porch) => `Подъезд ${porch}`;

const SelectPorch = ({ value, getPopupContainer, items }) => {
  const dispatch = useDispatch();
  const { setAddrPorchValue } = useRequestFilterCommands();

  const setFilterChanged = useSetFilterChanged();

  const handleChange = (value) => {
    dispatch(setAddrPorchValue(value));
    setFilterChanged();
  };

  return (
    <Select
      {...compactMultiSelectTagProps}
      mode="multiple"
      allowClear={true}
      getPopupContainer={getPopupContainer}
      placeholder="Подъезды"
      optionFilterProp="searchtext"
      style={{ width: 117 }}
      value={value}
      onChange={handleChange}
    >
      {items?.map((item) => (
        <Select.Option
          key={item}
          value={item}
          searchtext={item}
        >
          {createContent(item)}
        </Select.Option>
      ))}
    </Select>
  );
};

export default memo(SelectPorch);
